import { apiRequestWithAutoRefresh } from '../utils/apiUtils'
import type { GateResult } from '../types'

// 計時器統一 Gate 檢查結果（gate-contract.md §2）
export interface TimerGateCheckResult {
  blocked: boolean
  gates: GateResult[]
}

// 計時器閘門：一次取回所有「使用者狀態型」鎖定（過期文件 / 必讀公告 / 個資未填…）
// 取代舊的 checkOverdueDocuments + checkAnnouncementGate 兩支獨立呼叫
export const checkTimerGates = async (): Promise<TimerGateCheckResult> => {
  const result = await apiRequestWithAutoRefresh('/gates/timer', { method: 'GET' })
  return result.data
}

// ==================== 統一導出 ====================

export const gateService = {
  checkTimerGates
}
